import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Container = styled.div<SizeProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const TicketRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding: 0 16px;
  gap: 10px;
`;

export const UnreadDot = styled.div`
  width: 6px;
  flex-shrink: 0;
  padding: 25px 15px 5px 5px;
`;

export const TicketContent = styled.div`
  flex: 1;
  padding: 15px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
`;

export const TicketDate = styled.div`
  flex-shrink: 0;
  padding: 17px 0;
`;
